<div class="container not-found min-vh-100 d-flex justify-content-center align-items-center flex-column">
  <div [innerHTML]="transformYourHtml(data.content)">

  </div>
  <div class="mt-3">
    <app-rectangle-button [label]="data.link.title" [routerLink]="data.link.url" dark></app-rectangle-button>
  </div>
</div>
